export default "__VITE_ASSET__745e6448__"